import { render, staticRenderFns } from "./GeneralHeader.vue?vue&type=template&id=7a4cf98c&scoped=true"
import script from "./GeneralHeader.vue?vue&type=script&lang=ts"
export * from "./GeneralHeader.vue?vue&type=script&lang=ts"
import style0 from "./GeneralHeader.vue?vue&type=style&index=0&id=7a4cf98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cf98c",
  null
  
)

export default component.exports